<template>
	<div>
		<navigator :index="1"></navigator>
		<div class="localhost">
			<div class="localhostText">首页/<span style="color:#333;">应用案例</span></div>
		</div>
		<div class="example">
			<div class="exampleTitle">应用案例</div>
			<div class="exampleDate"></div>
		</div>
		<div class="exampleListBox">
			<router-link to="/example01" class="exampleItem">
				<div class="exampleItemLeft">
					<img style="display:block;width:100%;height:100%;" src="../resource/images/img15.png"
						alt="建发·厦门文澜和著">
				</div>
				<div class="exampleItemRight">
					<div class="exampleItemRightTitle">建发·厦门文澜和著</div>
					<div class="exampleItemRightDate">2020年2月29日</div>
					<div class="exampleItemRightContent">筑橙科技与中建海峡建设发展有限公司在建发·厦门文澜和著项目高层业态开展合作，进行外墙涂料机器人喷涂工作...</div>
					<div class="exampleMore">了解更多 ></div>
				</div>
			</router-link>
			<router-link to="/example02" class="exampleItem">
				<div class="exampleItemLeft">
					<img style="display:block;width:100%;height:100%;" src="../resource/images/img37.jpg"
						alt="瑞安金茂悦">
				</div>
				<div class="exampleItemRight">
					<div class="exampleItemRightTitle">瑞安金茂悦</div>
					<div class="exampleItemRightDate">2020年2月29日</div>
					<div class="exampleItemRightContent">筑橙科技与中国金茂在瑞安金茂悦02-41地块20#、21#楼达成合作，开展外墙涂料机器人喷涂试点工作。</div>
					<div class="exampleMore">了解更多 ></div>
				</div>
			</router-link>
		</div>
		<foot></foot>
	</div>
</template>

<script>
	import foot from "../components/foot"
	import navigator from "../components/navigator"
	export default {
		components: {
			foot,
			navigator
		},
		name: 'example01',
		data() {
			return {

			}
		},
		methods: {
			open() {
				window.open("http://qingflow.com/f/a445638c?qfchannel=Website")
				// window.location.href = "http://qingflow.com/f/a445638c?qfchannel=Website"
			},
			reminder() {
				this.hint.hint()
			}
		}
	}
</script>

<style scoped>
	.exampleMore {
		font-size: 14px;
		color: #ea5b24;
		text-align: center;
		width: 124px;
		line-height: 42px;
		border: 1px solid #ea5b24;
		border-radius: 6px;
	}

	.exampleItemRightContent {
		line-height: 28px;
		font-size: 20px;
		font-weight: 400;
		text-align: left;
		color: #666;
	}

	.exampleItemRightDate {
		height: 22px;
		font-size: 16px;
		font-weight: 400;
		text-align: left;
		color: #bbb;
	}

	.exampleItemRightTitle {
		height: 42px;
		font-size: 30px;
		font-weight: 400;
		text-align: left;
		color: #333;
	}

	.exampleItemRight {
		display: flex;
		justify-content: space-between;
		flex-direction: column;
	}

	.exampleItem {
		width: 1040px;
		display: flex;
		margin: 50px auto 0;
	}

	.exampleItem:nth-last-child(1) {
		margin-bottom: 100px;
	}

	.exampleItemLeft {
		flex: 0 0 auto;
		width: 335px;
		height: 202px;
		background-color: #eee;
		margin-right: 30px;
	}

	.exampleListBox {
		min-height: calc(100vh - 65px - 85px - 156px - 279px - 86px - 50px);
	}

	.lastHint {
		text-indent: 2em;
		margin: 50px auto;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		/* color: #707070; */
		color: #666;
		line-height: 26px;
		letter-spacing: 0.77px;
	}







	.exampleDate {
		line-height: 22px;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #bbb;
		/* padding-bottom: 30px; */
		box-sizing: border-box;
		border-bottom: 1px solid #eee;
		height: 30px;
	}

	.example {
		width: 1040px;
		margin: 0 auto;
		overflow: hidden;
	}

	.exampleTitle {
		margin-top: 70px;
		line-height: 56px;
		font-size: 40px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: left;
		color: #333;
	}

	.localhostText {
		width: 1040px;
		line-height: 42px;
		font-size: 30px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: left;
		color: #333;
		margin: 0 auto;
	}

	.localhost {
		height: 85px;
		display: flex;
		align-items: center;
		background-color: #f6f7f7;
	}

	.localhostText {
		width: 1200px;
		margin: 0 auto;
		font-size: 18px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #999;
	}

	.title {
		line-height: 56px;
		font-size: 40px;
		font-family: PingFang SC, PingFang SC-Heavy;
		font-weight: 800;
		text-align: left;
		color: #333;
		margin-top: 60px;
	}

	.logo {
		width: 154px;
		height: 38px;
	}

	.navigation {
		width: 1200px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.navigator {
		display: flex;
		align-items: center;
	}

	.navigatorText {
		line-height: 25px;
		font-size: 18px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		color: #fff;
		margin-left: 60px;
		cursor: pointer;
		transition: all .3s;
		position: relative;
	}

	.navigatorText:nth-child(1) {
		margin-left: 0px;
	}

	.navigatorText:hover {
		color: #EA5B24;
	}

	.block {
		position: absolute;
		/* width: 33px; */
		width: 100%;
		height: 2px;
		background-color: #fff;
		transition: all .3s;
		left: 0;
		bottom: -5px;
		opacity: 0;
	}

	.navigatorText:hover .block {
		background-color: #EA5B24;
		opacity: 1;
	}

	.navigationBg {
		width: 100%;
		background-color: rgba(0, 0, 0, 0.66);
		display: flex;
		justify-content: center;
		/* position: absolute;
		left: 0;
		top: 0; */
	}

	.navigatorText {
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/pages/exampleList.vue